import React, { useContext } from 'react';
import GlobalContext from '../../../../utils/GlobalContext';

const AnalyseTestResultsBlock = ({ analyseHandler, textStyle, linkColor }) => {
  const { locales } = useContext(GlobalContext);

  return (
    <div
      className={`add-field ${textStyle} custom-font-body`}
      onClick={analyseHandler}
      style={{
        color: linkColor,
        borderBottomColor: linkColor,
      }}
    >
      {locales.testing.testCard.analyseTestResults}
      <div className="border" />
    </div>
  );
};

export default AnalyseTestResultsBlock;
